export { BlendedPersonalizedProductCarousel } from './blended-carousel';
